import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';

@Component({
  selector: 'app-price-breakdown-ttt',
  templateUrl: './price-breakdown-ttt.indra.component.html',
  styleUrls: ['./price-breakdown-ttt.component.scss']
})
export class INDRAPriceBreakdownTttComponent implements OnInit {
 
	currency: any;
	timeToThink: any;

	constructor(
		private bfmStorage: INDRABFMDataStorageService,
		private currencyService: INDRACurrencyService
	) { 
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
        this.timeToThink = this.bfmStorage.INDRA_getTimeToThink();
	}

  ngOnInit() {
  }

}
